import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { Query } from 'src/app/models/Query';
import { QueryService } from 'src/app/queries/queries.service';

import { VeldaArticlesState } from '../../velda-articles.state';

@Component({
    selector: 'app-velda-articles-brands-list',
    templateUrl: './velda-articles-brands-list.component.html',
    styleUrls: ['./velda-articles-brands-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class VeldaArticlesBrandsListComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(VeldaArticlesState.queries) queries$: Observable<Query[]>;
    query: Query;
    data: any[];
    loading = true;
    queryError = false;

    constructor(private queryService: QueryService) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.queries$.subscribe((queries) => {
                this.query = queries?.find((q) => q?.type === 'BRANDS');
                this.queryService.runQueryByType('BRANDS').subscribe((res) => {
                    if (JSON.parse(JSON.stringify(res)).errors) {
                        this.queryError = true;
                    } else {
                        this.queryError = false;
                        this.data = JSON.parse(JSON.stringify(res)).data.entries;
                    }
                });
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
